module.exports = __webpack_public_path__ + "static/media/ntig-white.a6082a2e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/ntig-white.svg
// module id = 61
// module chunks = 0